import { Graphics, Container, Text, Point, Rectangle, ObservablePoint, Texture, extras } from 'pixi.js'
import { grid } from './index'
import RoomLabel from './RoomLabel'
import RoomFloor from './RoomFloor'
import RoomController from './RoomController'

export default class Room extends Graphics {

  constructor(config, item) {
    super()

    // id
    this.id = item ? item.id : grid.uniqueId()

    // アイテム定義
    this.config = config

    // 寸法
    this.dimension = new ObservablePoint(this.updateDimension, this, item ? item.width : 2, item ? item.height : 2)

    // 座標
    this.coordinate = new ObservablePoint(this.updateCoordinate, this, item ? item.x : 0, item ? item.y : 0)

    // 角度
    this.angle = item ? item.rotation : 0

    // 子アイテム
    this.items = new Container()
    this.addChild(this.items)

    // 床
    this.floor = new RoomFloor(this)

    // ラベル
    this.label = new RoomLabel(this)

    // コントローラー
    this.controller = new RoomController(this)

    this.update()

    return this
  }

  get area() {
    let tatami = (this.dimension.x * this.dimension.y) / 2
    // let tatami = _.floor((this.dimension.x * this.dimension.y) / 2, 2)
    // return tatami * grid.shaku3 * grid.shaku3 * 2 * (this.config.floor_size_percent / 100)
    return _.round(tatami * grid.shaku3 * grid.shaku3 * 2 , 5) * (this.config.floor_size_percent / 100)
    // return _.floor(tatami * grid.shaku3 * grid.shaku3 * 2 , 2) * (this.config.floor_size_percent / 100)
  }

  get tsubo() {
    let tatami = (this.dimension.x * this.dimension.y) / 2
    return (tatami / 2) * (this.config.floor_size_percent / 100)
  }

  get calcWidth() {
    return grid.size * this.dimension.x
  }

  get calcHeight() {
    return grid.size * this.dimension.y
  }

  findItem(itemId) {
    return this.items.children.find(item => item.id == itemId)
  }

  getRoomBounds() {
    return new Rectangle(this.coordinate.x, this.coordinate.y, this.dimension.x, this.dimension.y)
  }

  update(silent = false) {
    this.updateDimension(silent)
    this.updateCoordinate(silent)
    this.items.children.forEach(item => {
      item.update(silent)
    })
  }

  updateDimension(silent = false) {
    // this.clear()
    // this.lineStyle(1, 0x666666)
    // this.beginFill(0xffffff, 0)
    // this.drawRect(0, 0, this.calcWidth, this.calcHeight)

    if (silent == false) {
      this.emit('updatedimension')
    }
  }

  updateCoordinate(silent = false) {
    this.position.set(this.coordinate.x * grid.size, this.coordinate.y * grid.size)
    if (silent == false) {
      this.emit('updatecoordinate')
    }
  }

  focus() {
    this.emit('focus')
    this.items.children.forEach(item => {
      item.highlight(true)
    })
  }

  blur() {
    this.emit('blur')
    this.items.children.forEach(item => {
      item.highlight(false)
    })
  }

  dragStart(grabPoint = null) {
    this.floor.cursor = 'grabbing'

    this.focus()

    this.emit('grab')

    if (!grabPoint) {
      grabPoint = new Point(this.calcWidth/2, this.calcHeight/2)
    }

    grid.on('pointermove', e => {
      this.emit('drag')
      const anchorPosition = e.data.getLocalPosition(this.parent)
      let div = 1 / grid.division
      this.coordinate.set(
        Math.round((anchorPosition.x - grabPoint.x) / grid.size / div) * div,
        Math.round((anchorPosition.y - grabPoint.y) / grid.size / div) * div
      )
    })

    // エディタ内で離した時
    grid.once('pointerup', e => {
      this.emit('drop')
      this.floor.cursor = 'grab'
      grid.off('pointermove')
      grid.off('pointerupoutside')
    })

    // エディタ外で離した時
    grid.once('pointerupoutside', e => {
      if (e.data.originalEvent.target.tagName != 'CANVAS') {
        this.emit('drop')
        this.floor.cursor = 'grab'
        grid.off('pointermove')
        grid.off('pointerup')
        this.emit('dropout')
      }
    })
  }

  destroy() {
    this.label.destroy()
    this.floor.destroy()
    this.controller.destroy()
    return super.destroy()
  }
}



// WEBPACK FOOTER //
// ./assets/js/display/Room.js